module.exports = __webpack_public_path__ + "img/safe-tip-img.23ec8f19.png";